/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu-feedback': {
    width: 1024,
    height: 1024,
    viewBox: '0 0 1024 1024',
    data: '<path d="M574.293333 138.666667a32 32 0 0 1 4.394667 63.701333l-4.352 0.298667H213.333333a10.666667 10.666667 0 0 0-10.368 8.234666L202.666667 213.333333v597.333334a10.666667 10.666667 0 0 0 8.234666 10.368L213.333333 821.333333h554.666667a10.666667 10.666667 0 0 0 10.368-8.234666L778.666667 810.666667v-356.309334a32 32 0 0 1 63.701333-4.352l0.298667 4.352V810.666667a74.666667 74.666667 0 0 1-68.522667 74.410666L768 885.333333H213.333333a74.666667 74.666667 0 0 1-74.410666-68.522666L138.666667 810.666667V213.333333a74.666667 74.666667 0 0 1 68.522666-74.410666L213.333333 138.666667h360.96zM650.666667 554.666667a32 32 0 1 1 0 64h-320a32 32 0 1 1 0-64h320z m-170.666667-170.666667a32 32 0 1 1 0 64h-149.333333a32 32 0 1 1 0-64h149.333333z m374.528-261.248a32 32 0 0 1 0 45.226667l-196.096 196.138666a32 32 0 0 1-45.226667-45.269333l196.096-196.096a32 32 0 0 1 45.226667 0z" p-id="4363"/>'
  }
})
